<template lang="pug">
// We use this to catch some common bugs in a way that's easier to debug.
// This catches rules that are old Vue2 Vee-Validate strings.
// It also catches when a single function has been passed in as :rules, rather than an array of functions
//    This is a very common error and can be hard to debug.
p.text-red.font-weight-bold(v-if='isDebugMode && !Array.isArray(rules)') FOR PROGRAMMER: rules isn't an array!: {{ rules }}

v-select(v-bind='$attrs' v-model='innerValue' :rules='rulesAugmented')
</template>

<script lang="ts">
import type { TypeValidationRules } from '@/common/Validation/ValidationRules';
import { PropType } from 'vue';

export default {
    inheritAttrs: false,
    emits: ['update:modelValue'],
    props: {
        rules: {
            type: Array as PropType<TypeValidationRules>,
            default: () => [],
        },
        modelValue: {
            type: String,
            default: undefined,
        },
    },
    data: () => ({
        innerValue: '',
        isDebugMode: import.meta.env.DEV,
    }),
    computed: {
        rulesAugmented(): TypeValidationRules {
            return this.rules;
        },
    },
    watch: {
        // Handles internal model changes.
        innerValue(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        // Handles external model changes.
        modelValue(newVal) {
            this.innerValue = newVal;
        },
    },
    created() {
        if (this.modelValue) {
            this.innerValue = this.modelValue;
        }
    },
};
</script>
